import type { RoleOption } from './api.ts'

/**
 * The função names an invite may give (#439, ADR 0024).
 *
 * Each pharmacy has its own roles, and the server looks the chosen name up in
 * every pharmacy the person is invited into -- so only a name all of them
 * have can be offered. `accountIds` absent means the inviter's own pharmacy,
 * whose roles are all the server sent. Case is ignored, as the server does.
 */
export function offeredRoleNames(
  roles: readonly RoleOption[],
  accountIds: readonly string[] | undefined,
): readonly string[] {
  if (accountIds === undefined) return [...new Set(roles.map((role) => role.name))]
  if (accountIds.length === 0) return []
  const namesIn = (accountId: string) =>
    new Set(
      roles.filter((role) => role.account_id === accountId).map((role) => role.name.toLowerCase()),
    )
  const [first, ...rest] = accountIds.map(namesIn)
  const shared = [...first!].filter((name) => rest.every((names) => names.has(name)))
  // Spelled as the first pharmacy spells it.
  return roles
    .filter((role) => role.account_id === accountIds[0] && shared.includes(role.name.toLowerCase()))
    .map((role) => role.name)
}
